import {FC} from 'react';

import {FloatingAlertLoader} from 'app/core/floatingAlert/basic/floatingAlertLoader';
import {ComponentContextWrapper} from 'app/utils/initialize/components/componentContextWrapper';
import {GemInitializeComponents} from 'app/utils/initialize/components/gemInitializeComponents';
import {GemInitializeOnce} from 'app/utils/initialize/components/gemInitializeOnce';
import {GemInitializeWebComponents} from 'app/utils/initialize/components/gemInitializeWebComponents';
import {GemInitializeProps} from 'app/utils/initialize/interface';

export const GemInitialize: FC<GemInitializeProps> = ({gemSettings, context}) => {
    return (
        <ComponentContextWrapper gemSettings={gemSettings}>
            <GemInitializeWebComponents />
            <GemInitializeComponents context={context} />
            <GemInitializeOnce />
            <FloatingAlertLoader />
        </ComponentContextWrapper>
    );
};
